import React from "react";

export default function NotificationTabs({
  activeTab,
  onTabChange,
  activeFiltersCount = 0,
}) {
  return (
    <div className="mb-4 bg-white rounded-xl shadow-md p-1 inline-flex flex-wrap gap-1">
      <button
        type="button"
        onClick={() => onTabChange("send")}
        className={`px-4 sm:px-6 py-2 rounded-lg font-medium text-xs md:text-sm transition-all ${
          activeTab === "send"
            ? "bg-red-500 text-white shadow-md"
            : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
        }`}>
        Send Notification
      </button>
      <button
        type="button"
        onClick={() => onTabChange("history")}
        className={`px-4 sm:px-6 py-2 rounded-lg font-medium text-xs md:text-sm transition-all flex items-center gap-1.5 ${
          activeTab === "history"
            ? "bg-red-500 text-white shadow-md"
            : "text-gray-600 hover:text-gray-800 hover:bg-gray-100"
        }`}>
        History
        {activeTab === "history" && activeFiltersCount > 0 && (
          <span className="bg-white text-red-500 text-xs font-bold px-2 py-0.5 rounded-full">
            {activeFiltersCount}
          </span>
        )}
      </button>
    </div>
  );
}
